import { getAudioBufferFromFile } from 'services/helpers/audio';
import { MIN_AUDIO_DURATION } from '../constants';
import { DurationErrorCode } from '../types';

export const getDurationFromAudioFile = async (file: File): Promise<number> => {
  try {
    const audioBuffer = await getAudioBufferFromFile(file);
    const { duration } = audioBuffer;

    return duration;
  } catch {
    return 0;
  }
};

export const validateAudioDuration = (duration: number) => {
  if (duration < MIN_AUDIO_DURATION) {
    throw DurationErrorCode.FileTooShort;
  }
};

export const parseDuration = (duration?: number) => {
  if (duration === undefined) {
    return undefined;
  }

  return Math.round(duration * 100) / 100;
};
